import { gql } from "@apollo/client";

export const QUERY_FORM3454L_VERSION = gql`
  query studentForm3454L(
    $studentFormId: ID!
    $formId: ID!
    $studentId: ID!
    $schoolId: ID!
    $studentMeetingId: ID!
  ) {
    studentForm3454L(
      studentFormId: $studentFormId
      studentId: $studentId
      formId: $formId
      schoolId: $schoolId
      studentMeetingId: $studentMeetingId
    ) {
      versionId
      formId
      formDate
      studentFullName
      studentDob
      environment
      instructionCurriculum
      positiveSupports
      motivatorsRewards
      restrictiveDisciplinaryMeasures
      crisisPlan
      dataCollectionProcedures
      caregiverProvisions
      formAction
      formStatus
    }
  }
`;
